import {
  Card,
  Row,
  Col,
  Input,
  Button,
  Select,
  DatePicker,
  Table,
  Tag,
  Modal,
  message,
} from "antd";
import {
  SearchOutlined,
  FilterOutlined,
  CalendarOutlined,
  FileTextOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import moment from "moment";
import "moment/locale/id";
import { useEffect, useState } from "react";

import MyPage from "../../../../../components/pages/Page";
import { useFetch } from "../../../../../hooks/useFetch";
import "../table-compact.css";

const { RangePicker } = DatePicker;

const toYmd = (m) => (m ? m.format("YYYYMMDD") : "");
const toDateTime = (m) => (m ? m.format("YYYY-MM-DD HH:mm:ss") : "");

const fmtD = (v) => {
  if (!v) return "-";
  const m = moment(v, ["YYYYMMDD", "DD/MM/YYYY", "DD-MM-YYYY"], true);
  return m.isValid() ? m.format("DD/MM/YYYY") : String(v);
};
const fmtDT = (v) => {
  if (!v) return "-";
  const m = moment(v, ["YYYYMMDDHHmmss", "YYYYMMDD", "YYYY-MM-DD HH:mm:ss"], true);
  return m.isValid() ? m.format("HH:mm:ss DD/MM/YYYY") : String(v);
};

const buildQuery = ({ awb, range, gateType, gateRange, page = 1, perPage = 5 }) => {
  const params = new URLSearchParams();
  if (awb) params.append("awb", awb);
  const [gStart, gEnd] = gateRange || [];
  const hasGate = !!gateType && !!gStart && !!gEnd;
  if (hasGate) {
    // mode gate: filter default (start_date/end_date) jangan dipakai
    params.append("gatetype", gateType);
    params.append("gatestart", toDateTime(gStart));
    params.append("gateend", toDateTime(gEnd));
  } else {
    const [start, end] = range || [];
    if (start) params.append("start_date", toYmd(start));
    if (end) params.append("end_date", toYmd(end));
  }
  params.append("page", page);
  params.append("perPage", perPage);
  return `api/v1/beacukai/inventory?${params.toString()}`;
};

// respons API: { data: { data: [...], total, page, perPage, totalPage } }
const mapRow = (r, i) => ({
  key: r.no_hawb ? `${r.no_hawb}-${i}` : i,
  noHawb: r.no_hawb ?? "-",
  tglHawb: r.tanggal_hawb ?? "-",
  noFlight: r.no_flight ?? "-",
  noBc11: r.no_bc11 ?? "-",
  tglBc11: r.tanggal_bc11 ?? "-",
  consignee: r.consignee ?? "-",
  kdDokIn: r.kode_dok_in ?? "-",
  noDokIn: r.nomor_dok_in ?? "-",
  tglDokIn: r.wk_in ?? "",
  kdDokOut: r.kode_dok_out ?? "-",
  noDokOut: r.nomor_dok_out ?? "-",
  tglDokOut: r.wk_out ?? "",
  statusBarang: r.status_barang ?? "-",
  history: "",
  raw: r,
});

const dv = (v) => (v === null || v === undefined || v === "" ? "-" : String(v));

const Field = ({ label, value, required }) => (
  <div style={{ marginBottom: "12px" }}>
    <div style={{ fontSize: "11px", fontWeight: 600, color: "#334155", marginBottom: "4px" }}>
      {label}
      {required && <span style={{ color: "red" }}> *</span>}
    </div>
    <Input readOnly value={dv(value)} />
  </div>
);

const DetailModal = ({ data, open, onClose }) => {
  const t = String(data?.type || "").toUpperCase();
  return (
    <Modal
      title={<b>Detail Tracking &amp; Movement Barang</b>}
      open={open}
      onCancel={onClose}
      footer={null}
      width={640}
    >
      <div style={{ fontSize: "11px", fontWeight: 600, color: "#334155", marginBottom: "4px" }}>
        JENIS KEGIATAN<span style={{ color: "red" }}> *</span>
      </div>
      <Input
        readOnly
        value={t === "IMPORT" ? "Import" : t === "EXPORT" ? "Export" : "-"}
        style={{ width: "100%", marginBottom: "12px" }}
      />
      <div style={{ fontSize: "11px", color: "#64748b", marginBottom: "12px" }}>
        Pilih jenis kegiatan operasional barang (Import / Export).
      </div>

      <Field label="KD. TPS" value={data?.kd_tps ?? data?.kode_tps} required />
      <Row gutter={12}>
        <Col span={12}>
          <Field label="NAMA PENGANGKUT" value={data?.nama_pengangkut ?? data?.flight_number ?? data?.no_flight} required />
        </Col>
        <Col span={12}>
          <Field label="NO. VOY/FLIGHT" value={data?.flight_number ?? data?.no_flight} required />
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={12}>
          <Field label="TGL. TIBA / EKSPOR" value={data?.hawb_date ? fmtD(data.hawb_date) : "-"} required />
        </Col>
        <Col span={12}>
          <Field label="KD GUDANG" value={data?.kd_gudang ?? data?.kode_gudang ?? data?.kode_gudang_ekspor ?? data?.kode_gudang_impor} />
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={12}>
          <Field label="REF NUMBER IN" value={data?.reff_number_in} />
        </Col>
        <Col span={12}>
          <Field label="REF NUMBER OUT" value={data?.reff_number_out} />
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={12}>
          <Field label="NO. BL/AWB" value={data?.hawb_number ?? data?.no_hawb} required />
        </Col>
        <Col span={12}>
          <Field label="TGL. BL/AWB" value={data?.hawb_date ? fmtD(data.hawb_date) : "-"} required />
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={12}>
          <Field label="NO. MASTER BL/AWB" value={data?.mawb_number} />
        </Col>
        <Col span={12}>
          <Field label="TGL. MASTER BL/AWB" value={data?.mawb_date ? fmtD(data.mawb_date) : "-"} />
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={12}>
          <Field label="ID CONSIGNEE / NPWP" value={data?.exportir_npwp} />
        </Col>
        <Col span={12}>
          <Field label="CONSIGNEE / SHIPPER" value={data?.consignee ?? data?.exportir_name} required />
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={12}>
          <Field label="BRUTO (KG)" value={data?.bruto} />
        </Col>
        <Col span={12}>
          <div style={{ fontSize: "11px", fontWeight: 600, color: "#334155", marginBottom: "4px" }}>
            KODE &amp; JUMLAH KEMASAN
          </div>
          <div style={{ display: "flex", gap: "8px" }}>
            <Input readOnly value={dv(data?.kode_kemas)} />
            <Input
              readOnly
              value={data?.jml_kemas === null || data?.jml_kemas === undefined ? "-" : `${data.jml_kemas} Kemasan`}
            />
          </div>
        </Col>
      </Row>
    </Modal>
  );
};

const DEFAULT_RANGE = [moment().subtract(7, "days"), moment()];
const PER_PAGE = 5;

export default () => {
  const [range, setRange] = useState(DEFAULT_RANGE);
  const [awbInput, setAwbInput] = useState("");
  const [gateType, setGateType] = useState();
  const [gateRange, setGateRange] = useState([]);
  const [page, setPage] = useState(1);
  const [query, setQuery] = useState(() =>
    buildQuery({ awb: "", range: DEFAULT_RANGE, page: 1, perPage: PER_PAGE })
  );
  const [rows, loading] = useFetch(query);
  const [lastUpdated, setLastUpdated] = useState(() => moment());
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    if (rows) setLastUpdated(moment());
  }, [rows]);

  const argsFor = (p) => ({
    awb: awbInput.trim(),
    range,
    gateType,
    gateRange,
    page: p,
    perPage: PER_PAGE,
  });

  const doSearch = () => {
    setPage(1);
    setQuery(buildQuery(argsFor(1)));
  };

  const onRangeChange = (dates) => {
    setRange(dates);
    if (dates?.[0] && dates?.[1]) {
      setPage(1);
      setQuery(
        buildQuery({ awb: awbInput.trim(), range: dates, gateType, gateRange, page: 1, perPage: PER_PAGE })
      );
    }
  };
  const doApplyGate = () => {
    if (!gateType) {
      message.warning("Pilih Tipe Waktu dulu (Gate In / Gate Out)");
      return;
    }
    const [gs, ge] = gateRange || [];
    if (!gs || !ge) {
      message.warning("Pilih periode Gate (mulai & selesai) dulu");
      return;
    }
    setPage(1);
    setQuery(
      buildQuery({ awb: awbInput.trim(), range, gateType, gateRange, page: 1, perPage: PER_PAGE })
    );
  };
  const handleTableChange = (pagination) => {
    const nextPage = pagination.current;
    setPage(nextPage);
    setQuery(buildQuery(argsFor(nextPage)));
  };
  const doRefresh = () => {
    setQuery(`${buildQuery(argsFor(page))}&t=${Date.now()}`);
  };
  const apiRows = Array.isArray(rows?.data) ? rows.data : [];
  const total = rows?.total ?? 0;
  const dataSource = apiRows.map(mapRow);
  const columns = [
    {
      title: "No HAWB",
      dataIndex: "noHawb",
      key: "noHawb",
      width: 110,
      fixed: "left",
    },
    { title: "Tanggal HAWB", dataIndex: "tglHawb", key: "tglHawb", width: 110, render: fmtD },
    { title: "No Flight", dataIndex: "noFlight", key: "noFlight", width: 95 },
    { title: "No BC11", dataIndex: "noBc11", key: "noBc11", width: 95 },
    { title: "Tanggal BC11", dataIndex: "tglBc11", key: "tglBc11", width: 110, render: fmtD },
    {
      title: "Consignee",
      dataIndex: "consignee",
      key: "consignee",
      width: 150,
    },
    {
      title: "Kode Dokumen In",
      dataIndex: "kdDokIn",
      key: "kdDokIn",
      width: 110,
    },
    {
      title: "Nomor Dokumen In",
      dataIndex: "noDokIn",
      key: "noDokIn",
      width: 130,
    },
    {
      title: "Tanggal Dokumen In",
      dataIndex: "tglDokIn",
      key: "tglDokIn",
      width: 160,
      render: fmtDT,
    },
    {
      title: "Kode Dokumen Out",
      dataIndex: "kdDokOut",
      key: "kdDokOut",
      width: 120,
    },
    {
      title: "Nomor Dokumen Out",
      dataIndex: "noDokOut",
      key: "noDokOut",
      width: 130,
    },
    {
      title: "Tanggal Dokumen Out",
      dataIndex: "tglDokOut",
      key: "tglDokOut",
      width: 160,
      render: fmtDT,
    },
    {
      title: "Status Barang",
      dataIndex: "statusBarang",
      key: "statusBarang",
      width: 130,
      render: (status) => {
        let color = "default";
        if (status === "Gate Out" || status === "Out") color = "green";
        else if (status === "Gate In" || (status && String(status).includes("In"))) color = "yellow";
        return (
          <Tag color={color} style={{ borderRadius: "12px" }}>
            ● {status}
          </Tag>
        );
      },
    },
    {
      title: "History Movement dan Tracking Lastmile",
      dataIndex: "history",
      key: "history",
      width: 160,
      render: (_, record) => (
        <a
          style={{ fontSize: "12px", textDecoration: "underline" }}
          onClick={() => setDetail(record.raw)}
        >
          [Lihat Detail Movement]
        </a>
      ),
    },
  ];

  return (
    <MyPage title={"Inventory"}>
      <div
        className="dashboard-filters"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "12px",
          marginBottom: "20px",
          paddingBottom: "4px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <span style={{ fontSize: "13px", color: "#1e293b", fontWeight: 500 }}>
            Filter Tampilan:
          </span>

          <Select
            defaultValue="harian"
            style={{ width: 100 }}
            size="small"
            options={[
              { value: "harian", label: "Harian" },
              { value: "mingguan", label: "Mingguan" },
            ]}
          />

          <Select
            defaultValue="bulanan"
            style={{ width: 105 }}
            size="small"
            options={[
              { value: "bulanan", label: "Bulanan" },
              { value: "tahunan", label: "Tahunan" },
            ]}
          />

          <RangePicker
            size="small"
            style={{ width: 350, flexShrink: 0 }}
            prefixIcon={
              <CalendarOutlined
                style={{ color: "#64748b", fontSize: "12px" }}
              />
            }
            suffixIcon={
              <CalendarOutlined
                style={{ color: "#64748b", fontSize: "12px" }}
              />
            }
            separator=" - "
            value={range}
            onChange={onRangeChange}
            format="DD MMMM YYYY"
          />
        </div>

        <div style={{ fontSize: "12px", color: "#475569" }}>
          Terakhir Diperbarui:{" "}
          <span style={{ fontWeight: 500 }}>
            {lastUpdated.clone().locale("id").format("DD MMMM YYYY, HH:mm [WIB]")}
          </span>
        </div>
      </div>

      <Row gutter={[16, 16]} style={{ marginBottom: "16px" }}>
        <Col xs={24} lg={10}>
          <Card
            title={
              <span>
                <SearchOutlined /> Tracking MAWB/HAWB
              </span>
            }
            bordered={false}
            bodyStyle={{ padding: "16px" }}
          >
            <div
              style={{
                marginBottom: "8px",
                fontSize: "12px",
                color: "#64748b",
              }}
            >
              Ketik Nomor MAWB atau HAWB...
            </div>
            <div style={{ display: "flex", gap: "8px" }}>
              <Input
                placeholder="Ketik Nomor MAWB atau HAWB..."
                style={{ flex: 1 }}
                value={awbInput}
                onChange={(e) => {
                  const v = e.target.value;
                  setAwbInput(v);
                  if (!v) {
                    setPage(1);
                    setQuery(buildQuery({ awb: "", range, gateType, gateRange, page: 1, perPage: PER_PAGE }));
                  }
                }}
                onPressEnter={doSearch}
                allowClear
              />
              <Button
                type="primary"
                icon={<SearchOutlined />}
                style={{ backgroundColor: "#1e3a8a" }}
                onClick={doSearch}
              >
                Cari
              </Button>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={14}>
          <Card
            title={
              <span>
                <FilterOutlined /> Filter by GateIn/Out Time
              </span>
            }
            bordered={false}
            bodyStyle={{ padding: "16px" }}
          >
            <Row gutter={[12, 12]} align="middle">
              <Col span={8}>
                <div
                  style={{
                    fontSize: "12px",
                    marginBottom: "4px",
                    color: "#64748b",
                  }}
                >
                  Tipe Waktu
                </div>
                <Select
                  placeholder="Pilih Tipe"
                  allowClear
                  style={{ width: "100%" }}
                  value={gateType}
                  onChange={setGateType}
                >
                  <Select.Option value="gatein">Gate In</Select.Option>
                  <Select.Option value="gateout">Gate Out</Select.Option>
                </Select>
              </Col>
              <Col span={16}>
                <div
                  style={{
                    fontSize: "12px",
                    marginBottom: "4px",
                    color: "#64748b",
                  }}
                >
                  Pilih Periode:
                </div>
                <div style={{ display: "flex", gap: "8px" }}>
                  <RangePicker
                    showTime
                    format="DD/MM/YYYY HH:mm"
                    style={{ flex: 1 }}
                    placeholder={["Mulai", "Selesai"]}
                    value={gateRange}
                    onChange={setGateRange}
                  />
                  <Button
                    type="primary"
                    icon={<FilterOutlined />}
                    style={{ backgroundColor: "#334155" }}
                    onClick={doApplyGate}
                    loading={loading}
                  >
                    Terapkan Filter
                  </Button>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      <Card
        title={
          <span>
            <FileTextOutlined /> Rincian Data Inventory & Pergerakan Barang
          </span>
        }
        extra={
          <Button
            type="text"
            icon={<ReloadOutlined />}
            onClick={doRefresh}
            loading={loading}
            title="Refresh data"
          />
        }
        bordered={false}
      >
        <Table
          className="bv2-compact"
          columns={columns}
          dataSource={dataSource}
          loading={loading}
          pagination={{
            current: page,
            pageSize: PER_PAGE,
            total,
            showSizeChanger: false,
            showTotal: (t) => `Total ${t} data`,
          }}
          onChange={handleTableChange}
          scroll={{ x: 1800 }}
          bordered
          size="small"
        />
      </Card>
      <DetailModal data={detail} open={!!detail} onClose={() => setDetail(null)} />
    </MyPage>
  );
};
